import PopupResetPassword from './PopupResetPassword';

export default PopupResetPassword;
